import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pa_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// ─────────────────────────────────────────────────────────────
// 401 session-recovery interceptor (Mobile ARIA Phase 1)
// ─────────────────────────────────────────────────────────────
// When ANY authenticated request returns 401, the token is stale/invalid.
// We:
//   1. Clear the stored token so subsequent requests do not loop.
//   2. Emit a global "aria:session-expired" CustomEvent so a UI-level
//      listener (SessionExpiredDialog) can prompt the clinician for
//      re-authentication WITHOUT dropping their unsaved question.
//
// Public endpoints (login, signup, login-2fa, forgot/reset password,
// unauthenticated /auth/me probe on cold-start) MUST NOT trigger the
// dialog — a 401 there simply means "wrong password". We identify those
// by URL suffix so no server-side change is required.
const PUBLIC_AUTH_SUFFIXES = [
  "/auth/login",
  "/auth/login-2fa",
  "/auth/signup",
  "/auth/forgot-password",
  "/auth/reset-password",
  "/auth/verify-recovery",
];

function _isPublicAuthUrl(url) {
  if (!url || typeof url !== "string") return false;
  return PUBLIC_AUTH_SUFFIXES.some((s) => url.endsWith(s));
}

function _emitSessionExpired(detail) {
  try {
    if (typeof window !== "undefined" && typeof window.dispatchEvent === "function") {
      window.dispatchEvent(
        new CustomEvent("aria:session-expired", { detail: detail || {} }),
      );
    }
  } catch (_) { /* best-effort */ }
}

api.interceptors.response.use(
  (r) => r,
  (err) => {
    try {
      const status = err && err.response && err.response.status;
      const url = err && err.config && (err.config.url || "");
      const hadToken =
        typeof localStorage !== "undefined" &&
        !!localStorage.getItem("pa_token");
      if (status === 401 && hadToken && !_isPublicAuthUrl(url)) {
        try { localStorage.removeItem("pa_token"); } catch (_) { /* ignore */ }
        _emitSessionExpired({ url });
      }
    } catch (_) { /* best-effort */ }
    return Promise.reject(err);
  },
);
